/** @jsxImportSource theme-ui */
import { jsx } from 'theme-ui';
import { Box, Heading } from '@theme-ui/components';
import SubscribeHeaderForm from './SubscribeHeaderForm';

const SubscribeHeader = ({ pageUrl, title, formName }) => (
  <Box p={4} pb={0} color="white" bg="primary">
    <Heading sx={{ textAlign: 'center' }} variant="lightHeading" as="h2">
      {title}
    </Heading>
    <SubscribeHeaderForm
      pageUrl={pageUrl}
      formName={formName}
      formStyle={formStyle}
    />
  </Box>
);

const formStyle = {
  justifyContent: 'center',
  alignContent: 'center',
  minHeight: 105,
  mb: 2,
  '.hs-subscribe-input': {
    width: '60%',
    height: 38,
    p: 2,
    m: 0,
    fontSize: 1,
    bg: 'white',
  },
  '.hs-subscribe-btn': {
    height: 38,
    border: '2px solid white',
    m: 0,
    ml: 2,
    '&:hover': {
      boxShadow: 'inset 0 0 0 1px rgba(255,255,255, 0.9)',
    },
  }
};

export default SubscribeHeader;
